module.exports = __webpack_public_path__ + "media/images/promotion/3-7dd599f6c777b24b4a57e0d57d5258ab.png";